import styled, { css } from 'styled-components';

import { Text } from '@/nova/components';
import { CFG } from '../../../../../theme/configurator-tokens';
import { MOBILE } from '../../mobile.tokens';

export const Root = styled.div<{ $overlay: boolean }>`
  z-index: 30;
  padding-top: env(safe-area-inset-top, 0px);
  pointer-events: none;
  ${({ $overlay }) =>
    $overlay
      ? css`
          position: absolute;
          inset: 0 0 auto 0;
        `
      : css`
          position: relative;
          flex-shrink: 0;
        `}
`;

export const Scrim = styled.div`
  pointer-events: none;
  position: absolute;
  inset: 0 0 auto 0;
  z-index: -1;
  height: 106px;
  background-image: ${MOBILE.headerFade};
`;

export const Row = styled.div`
  position: relative;
  margin-top: 8px;
  display: flex;
  height: 48px;
  align-items: center;
  justify-content: center;
`;

export const BackButton = styled.button`
  pointer-events: auto;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  width: 48px;
  height: 48px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
`;

export const SkipButton = styled.button`
  pointer-events: auto;
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  width: 48px;
  height: 48px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
`;

export const SkipLabel = styled(Text)`
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  color: ${CFG.base50};
`;

export const Segments = styled.div`
  display: flex;
  width: 197px;
  align-items: center;
  justify-content: space-between;
`;

export const Segment = styled.span<{ $state: 'active' | 'done' | 'idle' }>`
  width: 46px;
  border-radius: 18px;
  height: ${({ $state }) => ($state === 'active' ? 6 : 4)}px;
  background: ${({ $state }) =>
    $state === 'active' ? MOBILE.segActive : $state === 'done' ? MOBILE.segDone : MOBILE.segIdle};
`;

export const Title = styled(Text)<{ $gradient: string }>`
  margin-top: -3px;
  text-align: center;
  font-size: 16px;
  font-weight: 900;
  /* Gradient text clips to the glyph box, so keep enough leading for descenders. */
  line-height: 1.25;
  background-image: ${({ $gradient }) => $gradient};
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
`;
